/**
 * 4가지 관리 시스템 공용 정의.
 * 중앙 허브(managementsystem.tsx)와 네비 컴포넌트(ManagementHeader / ManagementMobileNav)가
 * 공유한다. 현재 콘텐츠가 구현된 것은 'operation'(운영관리)뿐 — 나머지는 준비 중 placeholder.
 */
export type ManagementKey = "life" | "study" | "operation" | "space";

export interface ManagementPage {
    key: ManagementKey;
    label: string;
}

export const MANAGEMENT_PAGES: ManagementPage[] = [
    { key: "life", label: "생활관리" },
    { key: "study", label: "학습관리" },
    { key: "operation", label: "운영관리" },
    { key: "space", label: "공간관리" },
];

export function nextManagement(key: ManagementKey): ManagementPage {
    const idx = MANAGEMENT_PAGES.findIndex((p) => p.key === key);
    return MANAGEMENT_PAGES[(idx + 1) % MANAGEMENT_PAGES.length];
}

export function managementLabel(key: ManagementKey): string {
    return MANAGEMENT_PAGES.find((p) => p.key === key)?.label ?? "";
}
